import React from 'react'
import classnames from 'classnames/dedupe'

export const FieldSet = (props) => {
  const { className, children, style, ...otherProps } = props
  return (
    <div className={classnames('fieldset-special', className)} {...otherProps}>
      {children}
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/demographics/helpers/fieldSet.js